export const hasTextOverflow = (element: HTMLDivElement | null) => {
  const visibleHeight = element?.clientHeight || 0
  const totalHeight = element?.scrollHeight || 0

  return visibleHeight < totalHeight
}
